import Form from "../CustomForm";
import React, {useEffect } from "react";
import useForm from "src/hooks/use-form";
import {useAlertContext} from "src/hooks/use-alert";
import ItemValidator from "src/validators/item-validator.ts";
import { Createitem, UpdateItem } from "src/apis/item";
import { useNavigate } from "react-router-dom";
import ItemTypes from "src/util/utility_enums";


const validator = new ItemValidator();
// For successful validation, isTouched has to be true and has error has to be false for each field
// 





// To create a form, Create this object with eack key as the field of the form to create
var properties = {
  serialNumber: { value: "", type: "text", isTouched: false, hasError: false },
  itemType: {
    value: "",
    type: "select",
    isTouched: false,
    hasError: false,
    enum: ItemTypes
  },
 


  thresholdCritical: {
    value: "",
    type: "number",
    isTouched: false,
    hasError: false,
  },

  thresholdHigh: {
    value: "",
    type: "number",
    isTouched: false,
    hasError: false,
  },
  
  thresholdMedium: {
    value: "",
    type: "number",
    isTouched: false,
    hasError: false,
  },
  thresholdLow: {
    value: "",
    type: "number",
    isTouched: false,
    hasError: false,
  },
  active: {
    value: true,
    type: "checkbox",
    checked: true,
    isTouched: true,
    hasError: false,
  },
  alarm: {
    value: false,
    type: "checkbox",
    checked: false,
    isTouched: true,
    hasError: false,
  },
  itemDescription: {
    value: "",
    type: "text",
    multiline: true,
    isTouched: true,
    hasError: false,
  },
};

export default function Item({ props }) { //props contain data regarding asset to from parent component
    console.log("item for update : ",props.item)
  
      useEffect(() => {
        console.log("in useEffect start ")
        for (const prop in props.item) {
          if (properties[prop] !== undefined) {
            properties[prop].value = props.item[prop];
            properties[prop].isTouched = true;
          }
        }
      }, [props.item]);
    
    






  // const [first, setfirst] = useState(false);
  const navigate = useNavigate();
  const alert = useAlertContext();
  // useEffect(() => {
  //   if (props.site) {
  //     for (const prop in props.site) {
  //       if (properties[prop] !== undefined) {
  //         properties[prop].value = props.site[prop];
  //         properties[prop].isTouched = true;
  //       }
  //     }
  //   }
  // }, [props.site]);

  //

  const { inputs, errorMessages, isValid, hasError, submitValidationHandler } =
    useForm(validator, properties);

   
  const handleSubmit = async (event) => {
    event.preventDefault();
    submitValidationHandler(event);
    if (isValid && !hasError) {
      let data = {}; //data to send to backend

      for (const input in inputs) {
        if (input === 'itemType') {
          data[input] = { 
            
            id: inputs[input].value, 
            description: "",
            name: "",
           unitOfMeasure: ""  
            
            // filling of json body dynamically
          
          
          }; 
        } else {
          data[input] = inputs[input].value;
        }
      }
      var response;
      var message;
      console.log(data);
      data.asset = {
        id: props.assetData.id,
        name: props.assetData.name
      };  //adding more required fields
      data.building = { id: props.assetData.buildingId };
      data["lastRegisteredValue"]=0;
      data["itemProtocol"]=""
      

 

      //APIS CALLING
      if (!props.item) {
        response = await Createitem(data);
        message = "Item created successfully!";
      } else {
        // data.id = props.asset.id;
        data.id = props.item.id;
        response = await UpdateItem(data);
        message = "Item updated successfully!";
      }

      console.log("submit:" + JSON.stringify(response));
      if (response.success) {
        // success alert
        alert.setSuccess((prev) => [...prev,{
          status: true,
          message: message,
          index:prev.length
        }]);
        if (isNaN(props.steps)) {
          return props.custom ? props.onSubmit(false, true) : navigate("..");
        }
        return props.handleNext({
          id: response.object.id,
          name: data.name,
        });
      } else {
        alert.setError((prev) => [...prev,{ status: true, messages: response.errors,index:prev.length }]);
        return props.custom ? props.onSubmit(false) : null;
      }
    }
    return props.custom ? props.onSubmit(false) : null;
  };

  return (
    <>
      <Form
        title={"Item"}
        inputs={inputs}
        errorMessages={errorMessages}
        isValid={isValid}
        custom={props.custom ?? false}
        hasError={hasError}
        activeStep={props.activeStep}
        steps={props.steps}
        onSubmit={handleSubmit}
        externalSubmit={props.externalSubmit ?? null}
        handleBack={props.handleBack ?? null}
      />
    </>
  );
}
